export const comments_5618658 = {"data":{"data":[],"links":{}}}